import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchReports, resetStateReports } from "../../app/slices/reportsSlice";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import AppDataTable from "../../components/AppDataTable/appDataTable";
import { Button } from "@mui/material";
import ReportDialog from "./ReportDialog";
import moment from "moment";
import { dateFormat } from "../../app/utils";

const ReportManagement = () => {
  const { data, status, error } = useSelector(({ reports }) => reports.get);
  const [list, setList] = useState(null);

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [method, setMethod] = useState("ADD");
  const [selectedReport, setSelectedReport] = useState(null);
  const dispatch = useDispatch();

  const columns = [
    {
      name: "published_date",
      label: "Date Posted",
    },
    {
      name: "title",
      label: "Title",
    },
    {
      name: "description",
      label: "Description",
    },
    {
      name: "attachment",
      label: "File Name",
    },
    {
      name: "statusDisplay",
      label: "Status",
    },
  ];

  //use effects
  useEffect(() => {
    loadResources();
    return () => {
      dispatch(resetStateReports());
    };
  }, []);

  useEffect(() => {
    if (data?.length > 0) {
      let _list = [];
      data?.forEach((row) => {
        _list.push({
          ...row,
          published_date: moment(row?.published_date).format(dateFormat),
          description:
            row?.description?.length > 60
              ? `${row?.description?.substring(0, 59)}...`
              : row?.description,
          statusDisplay:
            row?.status === "A"
              ? "Active"
              : row?.status === "I"
              ? "Inactive"
              : row?.status,
          overview:
            row?.overview?.length > 60
              ? `${row?.overview?.substring(0, 59)}...`
              : row?.overview,
        });
      });
      setList(_list);
    } else {
      setList([]);
    }
  }, [data]);

  //methods
  const loadResources = () => {
    dispatch(resetStateReports());
    dispatch(fetchReports());
  };

  //builders
  return (
    <>
      <div className="app-padding mt-20 mb-50">
        <Button
          variant="outlined"
          onClick={() => {
            setMethod("ADD");
            setSelectedReport(null);
            setIsOpenDialog(true);
          }}
        >
          + Post Report
        </Button>

        {status === "idle" && error === null && list && (
          <AppDataTable
            id="reports-list"
            actions={[
              {
                action: "View",
                onClick: (item) => {
                  window.open(
                    `${process.env.REACT_APP_SERVER_URL}/uploads/reports/${item?.attachment}`
                  );
                },
              },
              {
                action: "Update",
                onClick: (item) => {
                  setMethod("UPDATE");
                  setSelectedReport(item);
                  setIsOpenDialog(true);
                },
              },
            ]}
            columns={columns}
            data={list}
            emptyMessage="No reports found."
            rowsPerPageOptions={[10, 20, 50, 100]}
            downloadFileName={`TzFincert reports ${moment().format(
              "DD-MMM-YYYY"
            )}`}
          />
        )}
        {status === "loading" && (
          <LoadingContainer message={"Loading reports..."} />
        )}
        {status !== "loading" && error && (
          <ErrorContainer message={error?.message} onReload={loadResources} />
        )}
      </div>

      {/* Report dialog */}
      {isOpenDialog && (method === "UPDATE" ? selectedReport : true) && (
        <ReportDialog
          selectedReport={selectedReport}
          open={isOpenDialog}
          method={method}
          onClose={(refresh) => {
            setIsOpenDialog(false);
            if (refresh) {
              if (refresh) {
                loadResources();
              }
            }
          }}
        />
      )}
      {/* Report dialog */}
    </>
  );
};

export default ReportManagement;
